export default "__VITE_ASSET__c571d1a9__"